module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privatumo nuostatos",
	"footer.privacy.url": "https://www.grohe.lt/lt_lt/company/privacy.html",
	"footer.disclaimer.text": "Atsakomybė",
	"footer.disclaimer.url": "https://www.grohe.lt/lt_lt/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE WaterSystems konfigūratorius",
	"homepage.introtext": "Atsakykite į keletą klausimų ir sužinokite, kuri GROHE vandens sistema Jums tinkamiausia.",
	"homepage.buttonStart": "Pradėti",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 klaida: puslapis nerastas",
	"404.link.goBack": "Grįžti į pradinį puslapį",
	"configurator.button.seeResults": "Rodyti rezultatus",
	"question1.question": "Ar savo virtuvėje turite šalto ir karšto vandens tiekimą?",
	"question1.option1.text": "Virtuvėje turiu šaltą ir karštą vandenį",
	"question1.option2.text": "Virtuvėje turiu tik šaltą vandenį",
	"question2.question": "Koks vanduo virtuvėje Jums reikalingas?",
	"question2.option1.text": "Verdantis vanduo maisto ir gėrimų ruošimui",
	"question2.option2.text": "Atvėsintas ir gazuotas vanduo",
	"question2.option3.text": "Atvėsintas, gazuotas bei verdantis vanduo",
	"question3.question": "Ar norėtumėte palikti savo turimą virtuvės maišytuvą?",
	"question3.option1.text": "Noriu palikti",
	"question3.option2.text": "Noriu pakeisti į naują modelį",
	"question4.question": "Kuris būtų Jūsų pagrindinis maišytuvas?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Kuris maišytuvo snapo dizainas patinka?",
	"question5.option1.text": "L formos snapas",
	"question5.option2.text": "U formos snapas",
	"question5.option3.text": "C formos snapas",
	"question6.question": "Kuris maišytuvo snapo dizainas patinka?",
	"question6.option1.text": "L formos snapas",
	"question6.option2.text": "U formos snapas",
	"question6.option3.text": "C formos snapas",
	"question7.question": "Kokio paviršiaus maišytuvo pageidaujate?",
	"question7.option1.text": "Chromuoto paviršiaus",
	"question7.option2.text": "Nerūdijančio plieno paviršiaus",
	"question8.question": "Koks boilerio dydis Jums reikalingas?",
	"question8.option1.text": "M dydis (3 litrai)",
	"question8.option2.text": "L dydis (5.5 litrai)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water?",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"question10.question": "Ar savo virtuvėje turite šalto ir karšto vandens tiekimą?",
	"question10.option1.text": "Virtuvėje turiu šaltą ir karštą vandenį",
	"question10.option2.text": "Virtuvėje turiu tik šaltą vandenį",
	"results.title": "Jūsų {productGroupsCount, plural, \none {rezultatai} \nother {rezultatas}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pilnam maišytuvo sumontavimui taip pat reikės:",
	"results.newConfiguration.title": "Ar norite koreguoti savo pasirinkimą?",
	"results.newConfiguration.buttonText": "Konfigūruoti naują vandens sistemą.",
	"results.product.number": "Produkto numeris: #{number}",
	"results.product.button.productInformation": "Produkto informacija",
	"results.product.button.dealerLocator": "Ieškoti artimiausios pardavimo vietos",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Produkto informacija",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.lt_ltu.json
// module id = 785
// module chunks = 0